import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';

import MainNav from '@/components/layout/AppNavbar';
import { useTranslation } from 'react-i18next';

function SettingsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [toggled, setToggled] = useState(false);

  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/token')) return 'token';
    if (path.includes('/webhook')) return 'webhook';
    if (path.includes('/subscription-settings')) return 'subscriptionSettings';
    if (path.includes('/chat-settings')) return 'chatSettings';
    if (path.includes('/analytics/fan')) return 'analyticsFan';
    if (path.includes('/analytics') || path.includes('/revenue-dashboard')) return 'analyticsIncome';
    if (path.includes('/account/notification')) return 'notification';
    if (path.includes('/account')) return 'account';
    if (path.includes('/activity')) return 'activity';
    if (path.includes('/block-list')) return 'blockList';
    return 'account'; // default
  };

  const currentTab = getActiveTab();

  const handleMenuItemClick = (path) => {
    navigate(path);
    setToggled(false); // 點擊後關閉手機版 sidebar
  };

  return (
    <>
      <MainNav />
      <main className="nav-padding">
        <div className="container-lg">
          {/* 手機版 Toggle 按鈕 */}
          <div className="d-md-none mt-4 mb-3">
            <button
              className="btn btn-outline-primary"
              onClick={() => setToggled(!toggled)}
            >
              <FontAwesomeIcon icon={["fas", "bars"]} className="me-2" />
              {t('menu')}
            </button>
          </div>

          <div className="d-flex gap-4">
            {/* Sidebar */}
            <Sidebar
              className="settings-sidebar"
              rootStyles={{
                border: 'none',
                '@media (min-width: 768px)': {
                  position: 'sticky',
                  top: 'var(--nav-height)',
                  height: 'calc(100vh - var(--nav-height))',
                },
                '@media (max-width: 767px)': {
                  height: '100vh',
                },
              }}
              backgroundColor='rgba(255, 255, 255, 0.5)'
              width="230px"
              breakPoint="md"
              toggled={toggled}
              onBackdropClick={() => setToggled(false)}
            >
                <Menu
                  rootStyles={{ paddingTop: '1.5rem', }}
                  menuItemStyles={{
                    button: ({ active }) => ({
                      backgroundColor: active ? 'var(--primary-color)' : 'transparent',
                      color: active ? '#fff' : undefined,
                      paddingTop: '1rem',
                      paddingBottom: '1rem',
                      '&:hover': {
                        backgroundColor: active ? 'var(--primary-color)' : 'transparent',
                        color: active ? '#fff' : 'var(--primary-color)',
                      },
                    }),
                    icon: ({ active }) => ({
                      color: active ? '#fff' : 'var(--primary-color)',
                    }),
                    subMenuContent: {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  <SubMenu
                    label={t('account')}
                    icon={<FontAwesomeIcon icon={["fas", "user"]} />}
                    defaultOpen={currentTab === 'account' || currentTab === 'notification'}
                  >
                    <MenuItem
                      active={currentTab === 'account'}
                      onClick={() => handleMenuItemClick('/settings/account')}
                    >
                      {t('profile')}
                    </MenuItem>

                    <MenuItem
                      active={currentTab === 'notification'}
                      onClick={() => handleMenuItemClick('/settings/account/notification')}
                    >
                      {t('notify_settings')}
                    </MenuItem>
                  </SubMenu>

                  <MenuItem
                    icon={<FontAwesomeIcon icon={["fas", "chart-line"]} />}
                    active={currentTab === 'activity'}
                    onClick={() => handleMenuItemClick('/settings/activity')}
                  >
                    {t('activity')}
                  </MenuItem>

                  <MenuItem
                    icon={<FontAwesomeIcon icon={["fas", "ban"]} />}
                    active={currentTab === 'blockList'}
                    onClick={() => handleMenuItemClick('/settings/block-list')}
                  >
                    {t('block_list')}
                  </MenuItem>

                  <SubMenu
                    label={t('idols')}
                    icon={<FontAwesomeIcon icon={["fas", "universal-access"]} />}
                    defaultOpen={currentTab === 'subscriptionSettings' || currentTab === 'chatSettings'}
                  >
                    <MenuItem
                      active={currentTab === 'subscriptionSettings'}
                      onClick={() => handleMenuItemClick('/settings/idol/subscription-settings')}
                    >
                      {t('subscription_settings')}
                    </MenuItem>

                    <MenuItem
                      active={currentTab === 'chatSettings'}
                      onClick={() => handleMenuItemClick('/settings/idol/chat-settings')}
                    >
                      {t('chat_settings')}
                    </MenuItem>
                  </SubMenu>

                  <SubMenu
                    label={t('analytics')}
                    icon={<FontAwesomeIcon icon={["fas", "chart-pie"]} />}
                    defaultOpen={currentTab === 'analyticsIncome' || currentTab === 'analyticsFan'}
                  >
                    <MenuItem
                      active={currentTab === 'analyticsIncome'}
                      onClick={() => handleMenuItemClick('/settings/analytics/income')}
                    >
                      {t('analytics_income')}
                    </MenuItem>

                    <MenuItem
                      active={currentTab === 'analyticsFan'}
                      onClick={() => handleMenuItemClick('/settings/analytics/fan')}
                    >
                      {t('analytics_fan')}
                    </MenuItem>
                  </SubMenu>

                  <SubMenu
                    label={t('developer')}
                    icon={<FontAwesomeIcon icon={["fab", "dev"]} />}
                    defaultOpen={currentTab === 'token' || currentTab === 'webhook'}
                  >
                    <MenuItem
                      active={currentTab === 'token'}
                      onClick={() => handleMenuItemClick('/settings/developer/token')}
                    >
                      {t('token_management')}
                    </MenuItem>

                    <MenuItem
                      active={currentTab === 'webhook'}
                      onClick={() => handleMenuItemClick('/settings/developer/webhook')}
                    >
                      {t('webhook_settings')}
                    </MenuItem>
                  </SubMenu>
                </Menu>
              </Sidebar>

            <div className="mt-4 flex-fill" style={{ minWidth: 0 }}>
              <Outlet />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default SettingsPage;
